import React, { Component } from 'react';

import Button from 'react-bootstrap/Button';

import ConfirmDeletePopup from '../Controls/ConfirmDeletePopup.js';

import './CategoryList.css';

class AssetItemList extends Component {

    confirmDeletePopup = React.createRef();

    constructor(props) {
        super(props);

        this.state = {
            assets: []
        };
    }

    componentDidMount() {
        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=0&pageSize=10"
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ assets: data });
        })
        .catch(console.log)
    }

    reloadList = (startIndex, pageSize) => {
        fetch('asset_list', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            body: "startIndex=" + startIndex + "&pageSize=" + pageSize
        })
        .then(res => res.json())
        .then((data) => {
          this.setState({ assets: data });
        })
        .catch(console.log)
    }

    handleDelete = assetId => event => {
        event.preventDefault();
        this.confirmDeletePopup.current.request(() => this.performDelete(assetId));
    }

    performDelete = (assetId) => {

        fetch('asset_delete', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
                },
            body: "assetId=" + assetId
        })
        .then(res => res.json())
        .then(data =>
        {
            if ('true' === data[0].delete)
            {
                this.props.reloadAssets();
            }
        })
        .catch(console.log)
    }

    //column headings, styled and aligned like the muster point list
    renderHeader = (showAction) => {
        return (
            <div class="card musterHeaderCard">
                <div class="CategoryBody">
                <div class="musterHeaderRow">
                <span class="CategoryMarker musterHeaderSpacer"></span>
                <span class="CategoryItem musterHeading">Title</span>
                {showAction && <span class="musterHeading musterHeadingAction">Action</span>}
                </div>
                </div>
            </div>
        )
    }

    render() {
        const assets = this.state.assets;
        if (1 === this.props.accessLevel)
        {
            return (
                <React.Fragment>
                {this.renderHeader(true)}
                {assets.map((asset) => (
                <div class="card">
                    <div class="CategoryBody">
                    <form class="form-inline" name="frmDeleteAsset" onSubmit={this.handleDelete(asset.assetId)}>
                    <span class="CategoryMarker" style={{'background-color' : '#' + asset.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.props.showUpdateAsset(asset)} style={{ cursor: 'pointer' }}>{asset.asset}</h2>
                    <Button variant="danger" size="lg" type="submit" className="musterActionCol">Delete</Button><input type="hidden" name="assetId" value={asset.assetId} /></form>
                    </div>
                </div>
                ))}
                <ConfirmDeletePopup ref={this.confirmDeletePopup} />
                </React.Fragment>
            )
        }
        else
        {
            return (
                <React.Fragment>
                {this.renderHeader(false)}
                {assets.map((asset) => (
                <div class="card">
                    <div class="CategoryBody">
                    <div class="musterHeaderRow">
                    <span class="CategoryMarker" style={{'background-color' : '#' + asset.colour}}></span>
                    <h2 class="CategoryItem" onClick={() => this.props.showUpdateAsset(asset)} style={{ cursor: 'pointer' }}>{asset.asset}</h2>
                    </div>
                    </div>
                </div>
                ))}
                </React.Fragment>
            )
        }
    }
}

export default AssetItemList;
